<template>
  <div class="d-flex w-110">
    <div class="info-details">
      <h5>{{$t('stats.income_for')}}:</h5>
      <h2>
        {{ stats.income }}
        <span>{{currency.code}}</span>
      </h2>
      <!-- <p>
        <small class="green">+5%</small> since last week
      </p>-->
      <h5 class="pt-20">{{$t('stats.averange_for')}}:</h5>
      <h2>
        {{ stats.average }}
        <span>{{currency.code}}</span>
      </h2>
      <!-- <p>
        <small class="red">-5%</small> since last week
      </p>-->
      <h5 class="pt-20">{{$t('stats.orders_for')}}:</h5>
      <h2>
        {{ stats.orders }}
        <span>{{$t('stats.amount')}}</span>
      </h2>
      <!-- <p>
        <small class="green">+5%</small> since last week
      </p>-->
      <div class="label-box">
        <div class="label-wrapper"  v-if="!in_corporate">
        <div class="label">
          <span class="line blue" v-if="modes.delivery"></span>
          {{ modes.delivery ? `${$t('stats.income')} Delivery` : ''}}
          <span
            class="line yellow"
            v-if="modes.preorder"
          ></span>
          {{ modes.preorder ? `${$t('stats.income')} Preorder` : ''}}
          <span
            class="line green"
            v-if="modes.inside"
          ></span>
          {{ modes.inside ? `${$t('stats.income')} Inside` : ''}}
           <span
            class="line white"
            v-if="modes.rooms"
          ></span>
          {{ modes.rooms ? `${$t('stats.income')} Rooms` : ''}}
        </div>
      </div>
         
          <div class="label-wrapper" v-else>
          <div class="label" v-for="(cafe,index) in cafes" :key="cafe._id">
            <span
              class="line"
              :style="{
          background: colors[index % colors.length]
        }"
            ></span>

            {{ $t('stats.income') }} {{ cafe.name }}
          </div>
          </div>
        
      </div>
    </div>
  </div>
</template>

<style scoped>
.chart-container {
  width: min-content;
  margin-top: 3.3vh;
  display: block;
}

.w-110 {
  width: 110%;
}

small.red {
  color: #e2223b;
}

small.green {
  color: #11d180;
}

.pt-20 {
  padding-top: 2.2vh;
}

h2 {
  font-size: 4.4vh;
  margin: 0;
}

h2 span {
  font-size: 2vh;
}

.label-box {
  position: relative;
  height: 16vh;
}
 
 .label-wrapper {
   position: absolute;
   bottom: 0;
   max-width: 100%;
 }

.label {
  display: flex;
  flex-flow: row wrap;
  color: #ededed;
  width: 100%;
  position: relative;
  bottom: 0;
  font-size: 2vh;
  align-items: flex-end;
  align-items: baseline;
  line-height: normal;
}

.label .line {
  width: 4vh;
  margin: 1.1vh 2.2vh 0 0;
  height: 1vh;
  display: inherit;
  background: red;
}

.label .line.blue {
  background: #cbd9e6;
}
.label .line.yellow {
  background: #ffd2a8;
}
.label .line.green {
  background: #129b81;
}
.label .line.white {
  background: #ededed;
}

.chart-header {
  width: 117vh;
  display: flex;
  border-bottom: 1px solid #c4c4c4;
  border-radius: 1vh 1vh 0 0;
  background: #1d1d1b;
}

.chart-header h4 {
  cursor: pointer;
  padding: 2vh 3vh 2vh 3vh;
  color: #a4a3a1;
  margin-bottom: -0.3vh;
  z-index: 1;
  font-size: 1.8vh;
}

h4 span {
  color: #ededed;
}

.dropdown-content span {
  font-size: 2.2vh;
  padding: 1vh;
  display: block;
}

.chart-header h4.dropdown {
  padding-left: 29vh;
}

h4.active {
  border-bottom: 5px solid #bde1e4;
  color: #ededed;
}

h3,
h4,
h5,
p {
  margin-bottom: 0;
}

h5 {
  font-size: 1.8vh;
}

p {
  font-size: 1.5vh;
  color: #a4a3a1;
  line-height: 0.8;
}

h4,
h3 span {
  font-size: 1.8vh;
}
.info-details {
  background: #1d1d1b;
  height: auto;
  color: #ededed;
  margin-left: -1vh;
  border-radius: 0 0 1vh 0;
  padding: 3.3vh 0 3.3vh 3vh;
  width: inherit;
}
</style>

<script>
export default {
  props: {
    stats: Object,
    in_corporate: {
      type: Boolean,
      default: false,
    },
    cafes: Array,
    colors: Array,
    modes: {
      type: Object,
      default: () => {
        return {
          inside: true,
          preorder: true,
          delivery: true,
        };
      },
    },
  },
  computed: {
    currency() {
      return this.$store.state.currency;
    },
  },
};
</script>